export function createCalendarDotArray(data = [], facility_id) {
  let facilityData = []
  data.forEach((item) => {
    if (item?.facility_id === facility_id) {
      facilityData.push({
        date: item?.service_date_from,
        color: 'var(--inprogress-mobi-day-dot)',
        markCssClass: 'mark-width',
      })
    }
  })
  return facilityData
}
